import React, { useState } from 'react';
import HelpDrawer from './HelpDrawer.jsx';

/**
 * Self-contained help affordance: a round "?" button plus the drawer it opens.
 * Drop it into any topbar. `variant` tints the button for dark vs light bars.
 */
export default function HelpButton({ variant = 'dark' }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        className={`help-trigger help-trigger--${variant}`}
        onClick={() => setOpen(true)}
        title="Help & Documentation"
        aria-label="Open help"
        data-testid="help-button"
      >
        <i className="fa-solid fa-question" aria-hidden="true" />
      </button>
      <HelpDrawer isOpen={open} onClose={() => setOpen(false)} />
    </>
  );
}
